/**
 * Shared bits for the skill mapping screens.
 */
import React from 'react';

export const LEVEL_STYLE = {
  expert: 'bg-emerald-600 text-white border-emerald-600',
  ok: 'bg-emerald-50 text-emerald-800 border-emerald-300',
  needs_improvement: 'bg-amber-50 text-amber-800 border-amber-300',
  not_ok: 'bg-red-50 text-red-700 border-red-300',
  na: 'bg-slate-50 text-slate-400 border-slate-200',
};

export const SYMBOL = {
  expert: '◎', ok: '○', needs_improvement: '△', not_ok: '✕', na: '–',
};

export const LevelChip = ({ level, size = 'md', testid }) => {
  const cls = LEVEL_STYLE[level] || 'bg-slate-50 text-slate-300 border-slate-200';
  const dim = size === 'sm' ? 'w-6 h-6 text-[11px]' : 'w-8 h-8 text-sm';
  return (
    <span
      data-testid={testid}
      title={level ? level.replace(/_/g, ' ') : 'not assessed'}
      className={`inline-flex items-center justify-center rounded-md border font-semibold ${dim} ${cls}`}
    >
      {level ? SYMBOL[level] : ''}
    </span>
  );
};

export const LevelPicker = ({ levels, value, onChange, disabled, testid }) => (
  <div className="flex gap-1" data-testid={testid}>
    {levels.map((l) => {
      const active = value === l.key;
      return (
        <button
          key={l.key}
          type="button"
          disabled={disabled}
          title={l.label}
          onClick={() => onChange(l.key)}
          data-testid={testid ? `${testid}-${l.key}` : undefined}
          className={`w-8 h-8 rounded-md border text-sm font-semibold transition-colors ${
            active ? LEVEL_STYLE[l.key] : 'bg-white text-slate-400 border-slate-300 hover:border-teal-400'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          {l.symbol}
        </button>
      );
    })}
  </div>
);

export const SkillLegend = ({ levels }) => (
  <div className="flex flex-wrap items-center gap-3 text-[11px] text-slate-500" data-testid="skill-legend">
    {levels.map((l) => (
      <span key={l.key} className="inline-flex items-center gap-1">
        <span className={`inline-flex items-center justify-center w-5 h-5 rounded border text-[11px] font-semibold ${LEVEL_STYLE[l.key]}`}>
          {l.symbol}
        </span>
        {l.label}
      </span>
    ))}
  </div>
);

export const indexTone = (idx) => {
  if (idx === null || idx === undefined) return 'text-slate-400';
  if (idx >= 85) return 'text-emerald-700';
  if (idx >= 65) return 'text-teal-700';
  if (idx >= 45) return 'text-amber-700';
  return 'text-red-700';
};
